export enum PermissionEnum {
  READ = "READ",
  CREATE = "CREATE",
  DELETE = "DELETE",
  APPROVE = "APPROVE",
  CREATE_USER = "CREATE_USER",
  ADMIN = "ADMIN",
  GRANATECH = "GRANATECH",
  EDIT_USER = "EDIT_USER",
  READ_CORBAN_USER = "READ_CORBAN_USER",
  CREATE_CORBAN = "CREATE_CORBAN",
  EDIT_CORBAN = "EDIT_CORBAN",
  READ_USER = "READ_USER",
  READ_PROMOTER_USER = "READ_PROMOTER_USER",
  READ_CORBAN = "READ_CORBAN",
  READ_PROMOTER_CORBAN = "READ_PROMOTER_CORBAN",
  READ_PROPOSAL = "READ_PROPOSAL",
  WRITE_PROPOSAL = "WRITE_PROPOSAL",
  CONSULT_CPF = "CONSULT_CPF",
  FINANCIAL = "FINANCIAL",
};
